




































































import { mapState } from "vuex";
import { Component, Watch, Prop, Vue } from "vue-property-decorator";
import {
  Calendar,
  CalendarOptions,
  CalendarApi,
  EventInput,
} from "@fullcalendar/core";
import FullCalendar from "@fullcalendar/vue";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import bsPlugin from "@fullcalendar/bootstrap";
import listPlugin from "@fullcalendar/list";
import interactionPlugin from "@fullcalendar/interaction";
import { ScheduleDateFilter,ScheduleCalendarFilter2 } from "@/store/modules/types";

@Component({
  components: {
    FullCalendar,
  },computed: {
    ...mapState("schedule", ["view", "list"]),
  },
})
export default class CalendarView extends Vue {
  @Watch("list.filter", { deep: true })
  onFilterChanged() {
    this.refreshEvents();
  }
  options: CalendarOptions = {
    plugins: [
      dayGridPlugin,
      timeGridPlugin,
      bsPlugin,
      listPlugin,
      interactionPlugin,
    ],
    events: this.eventSource,
    eventClick: this.eventClick,
    dateClick: this.dateClick,
    headerToolbar: {
      left: "dayGridMonth,timeGridWeek,timeGridDay",
      center: "title",
      right: "today prevYear,prev,next,nextYear",
    },
    buttonText: {
      today: "Today",
      month: "Month",
      week: "Week",
      day: "Day",
      list: "List",
    },
    initialView: "dayGridMonth",
    themeSystem: "bootstrap",
  };
  eventSource(info, success, failure) {
    const dateFilter: ScheduleDateFilter = {
      timeSpan: null,
      from: info.startStr,
      to: info.endStr,
    };
    this.$store.commit("main/SET_LOADING", true);
    this.$store
      .dispatch("schedule/getCalendarViewEvents", dateFilter)
      .then((events) => success(events))
      .catch((error) => failure(error))
      .finally(() => this.$store.commit("main/SET_LOADING", false));
  }
  eventClick(info) {
    this.$emit("new-appt", info.event);
  }
  dateClick(info) {
    console.log(info);
  }

  refreshEvents() {
    const fullCalendar = (this.$refs.fullCalendar as InstanceType<typeof FullCalendar>).getApi();
    fullCalendar.refetchEvents();
    }
}
